const stores = [
  {
    No: 2,
    Name: "BOROUGH",
    Address: "302 Borough High Street, Borough, London, SE1 1JJ",
    Link: "https://deliveroo.co.uk/menu/london/borough/asia-villa-borough-high-street",
    tel: "02074075301",
    lat: 51.49966027660743,
    lng: -0.09641193226200846,
    BuisnessHour: [
      {
        days: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        Opening: "10.00",
        Closing: "23.00",
      },
    ],
  },
  // {
  //   No: 1,
  //   Name: "Upton Town",
  //   Address: "409 Katherine Road, London, E7 8LT",
  //   Link: "https://deliveroo.co.uk/menu/London/upton/asia-villa-upt",
  //   tel: "02085524488",
  //   lat: 51.54260363374026,
  //   lng: 0.036935625412983814,
  //   BuisnessHour: [
  //     {
  //       days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Sunday"],
  //       Opening: "11.00",
  //       Closing: "22.00",
  //     },
  //     { days: ["Friday", "Saturday"], Opening: "11.00", Closing: "23.00" },
  //   ],
  // },
  {
    No: 3,
    Name: "Canary Wharf",
    Address: "267 East India Dock Road, Poplar, London, E14 0EG",
    Link: "https://deliveroo.co.uk/menu/London/langdon-park/asia-villa-london",
    tel: "02036892619",
    lat: 51.511722897555906,
    lng: -0.009332689932862655,
    BuisnessHour: [
      {
        days: ["Monday", "Tuesday", "Wednesday", "Thursday"],
        Opening: "11.00",
        Closing: "23.00",
      },
      {
        days: ["Friday", "Saturday"],
        Opening: "11.00",
        Closing: "24.00",
      },
      {
        days: ["Sunday"],
        Opening: "11.00",
        Closing: "23.00",
      },
    ],
  },
  {
    No: 4,
    Name: "Romford",
    Address: "19 Victoria Road, Romford, RM1 2JT",
    Link: "https://deliveroo.co.uk/menu/London/hylands/asia-villa-romford",
    tel: "01708500705",
    lat: 51.574845622290994,
    lng: 0.1856502965794885,
    BuisnessHour: [
      {
        days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Sunday"],
        Opening: "11.00",
        Closing: "22.00",
      },
      {
        days: ["Friday", "Saturday"],
        Opening: "11.00",
        Closing: "22.30",
      },
    ],
  },
  {
    No: 6,
    Name: "Wood Green",
    Address: "462 Lordship Lane Wood Green, London, N17 7QY",
    Link: "https://deliveroo.co.uk/menu/London/downhills-park-tower-garden-estate/asia-villa",
    tel: "02088856176",
    lat: 51.598211087506144,
    lng: -0.09149663225465664,
    BuisnessHour: [
      {
        days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        Opening: "11.00",
        Closing: "22.30",
      },
      {
        days: ["Sunday"],
        Opening: "12.00",
        Closing: "22.30",
      },
    ],
  },
  {
    No: 5,
    Name: "Angel",
    Address: "379 St John St, London, EC1V 4LD",
    Link: "https://deliveroo.co.uk/menu/london/angel/asia-villa-st-john-street",
    tel: "02078372880",
    lat: 51.530166284097795,
    lng: -0.1054906034238478,
    BuisnessHour: [
      {
        days: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        Opening: "11.00",
        Closing: "22.00",
      },
    ],
  },
];
export default stores;
